import { Col } from 'antd';
import { useTranslation } from 'react-i18next';
import SwitchField from '../../../../../../components/fields/SwitchField';
import useSystemSwitchData from '../../../../../../utilities/useSystemSwitchData';

export type FlexibleDiscountProps = {
    name: string;
};

const colSpan = {
    md: 8,
    xs: 24,
};
const FlexibleDiscount = ({ name }: FlexibleDiscountProps) => {
    const { yesNoSwitch } = useSystemSwitchData();
    const { t } = useTranslation(['common']);

    return (
        <Col {...colSpan}>
            <SwitchField
                {...yesNoSwitch}
                name={`${name}.isEnabled`}
                {...t('common:moduleInput.flexibleDiscount.isEnabled', { returnObjects: true })}
            />
        </Col>
    );
};

export default FlexibleDiscount;
